export default __webpack_public_path__ + "static/media/github.66a22fec.svg";